/* Novex Kids - Salaozinho: filtros de prateleira e etapa (sections/nv-kids.liquid) */
(function () {
  function bind(root) {
    if (root.dataset.nvkReady) return;
    root.dataset.nvkReady = '1';
    var shelfBtns = root.querySelectorAll('[data-nvk-shelf]');
    var stepBtns = root.querySelectorAll('[data-nvk-step]');
    var boxes = root.querySelectorAll('[data-nvk-shelf-box]');
    var firstOn = root.querySelector('[data-nvk-shelf].is-on') || shelfBtns[0];
    var state = { shelf: firstOn ? firstOn.getAttribute('data-nvk-shelf') : '', step: 'tudo' };

    function mark(list, attr, value) {
      list.forEach(function (b) {
        var on = b.getAttribute(attr) === value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function apply() {
      mark(shelfBtns, 'data-nvk-shelf', state.shelf);
      mark(stepBtns, 'data-nvk-step', state.step);
      boxes.forEach(function (box) {
        var showBox = box.getAttribute('data-nvk-shelf-box') === state.shelf;
        box.hidden = !showBox;
        var visible = 0;
        box.querySelectorAll('[data-nvk-item]').forEach(function (item) {
          var ok = state.step === 'tudo' || item.getAttribute('data-nvk-item') === state.step;
          item.hidden = !ok;
          if (ok) visible++;
        });
        var empty = box.querySelector('.nvk-empty');
        if (empty) empty.hidden = visible > 0;
        var row = box.querySelector('.nvk-row');
        if (row) row.scrollLeft = 0;
      });
    }

    shelfBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.shelf = b.getAttribute('data-nvk-shelf');
        apply();
      });
    });
    stepBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.step = b.getAttribute('data-nvk-step');
        apply();
      });
    });
  }

  function carousel(root) {
    var box = root.querySelector('[data-nvk-carousel]');
    if (!box || box.dataset.nvkCarReady) return;
    box.dataset.nvkCarReady = '1';
    var slides = box.querySelectorAll('.nvk-slide');
    var dots = box.querySelectorAll('[data-nvk-dot]');
    if (slides.length < 2) return;
    var at = 0;
    var timer = null;
    var slow = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      at = (n + slides.length) % slides.length;
      slides.forEach(function (sl) {
        sl.style.transform = 'translateX(' + (at * -100) + '%)';
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-on', i === at);
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function play() {
      if (slow) return;
      stop();
      timer = window.setInterval(function () { show(at + 1); }, 6000);
    }

    var prev = box.querySelector('[data-nvk-prev]');
    var next = box.querySelector('[data-nvk-next]');
    if (prev) prev.addEventListener('click', function () { show(at - 1); play(); });
    if (next) next.addEventListener('click', function () { show(at + 1); play(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); play(); });
    });
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', play);
    box.addEventListener('focusin', stop);
    box.addEventListener('focusout', play);

    var startX = null;
    var startY = null;
    box.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      stop();
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        show(dx < 0 ? at + 1 : at - 1);
      }
      startX = null;
      startY = null;
      play();
    }, { passive: true });
    show(0);
    play();
  }

  function init() {
    document.querySelectorAll('[data-nvk]').forEach(function (root) {
      bind(root);
      carousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
